import parentTranslationMessages from '@/app-template/lib/i18n';

export default {
  zh: {
    ...parentTranslationMessages.zh,
    // add extra zh translations below
  },
  en: {
    ...parentTranslationMessages.en,
    // add extra en translations below
  }
}